export const CURRENCY_MAP = {
  AED: "UAE Dirham",
  AUD: "Australian Dollar",
  BDT: "Bangladeshi Taka",
  BRL: "Brazilian Real",
  CAD: "Canadian Dollar",
  CHF: "Swiss Franc",
  CNY: "Chinese Yuan",
  CZK: "Czech Koruna",
  DKK: "Danish Krone",
  EGP: "Egyptian Pound",
  EUR: "Euro",
  GBP: "British Pound Sterling",
  HKD: "Hong Kong Dollar",
  HUF: "Hungarian Forint",
  IDR: "Indonesian Rupiah",
  ILS: "Israeli New Shekel",
  INR: "Indian Rupee",
  JPY: "Japanese Yen",
  KRW: "South Korean Won",
  KWD: "Kuwaiti Dinar",
  MAD: "Moroccan Dirham",
  MXN: "Mexican Peso",
  MYR: "Malaysian Ringgit",
  NGN: "Nigerian Naira",
  NOK: "Norwegian Krone",
  NZD: "New Zealand Dollar",
  OMR: "Omani Rial",
  PHP: "Philippine Peso",
  PKR: "Pakistani Rupee",
  PLN: "Polish Zloty",
  QAR: "Qatari Riyal",
  RON: "Romanian Leu",
  RUB: "Russian Ruble",
  SAR: "Saudi Riyal",
  SEK: "Swedish Krona",
  SGD: "Singapore Dollar",
  THB: "Thai Baht",
  TRY: "Turkish Lira",
  TWD: "Taiwan Dollar",
  USD: "US Dollar",
  VND: "Vietnamese Dong",
  ZAR: "South African Rand",
};

export const CURRENCY_SYMBOL_MAP = {
  AED: "د.إ",
  AUD: "A$",
  BDT: "৳",
  BRL: "R$",
  CAD: "C$",
  CHF: "Fr",
  CNY: "¥",
  CZK: "Kč",
  DKK: "kr",
  EGP: "£",
  EUR: "€",
  GBP: "£",
  HKD: "HK$",
  HUF: "Ft",
  IDR: "Rp",
  ILS: "₪",
  INR: "₹",
  JPY: "¥",
  KRW: "₩",
  KWD: "د.ك",
  MAD: "د.م.",
  MXN: "$",
  MYR: "RM",
  NGN: "₦",
  NOK: "kr",
  NZD: "NZ$",
  OMR: "ر.ع.",
  PHP: "₱",
  PKR: "₨",
  PLN: "zł",
  QAR: "ر.ق",
  RON: "lei",
  RUB: "₽",
  SAR: "ر.س",
  SEK: "kr",
  SGD: "S$",
  THB: "฿",
  TRY: "₺",
  TWD: "NT$",
  USD: "$",
  VND: "₫",
  ZAR: "R",
};

export const CURRENCY_OPTIONS = Object.entries(CURRENCY_MAP).map(
  ([code, name]) => ({ value: code, label: `${code} — ${name}` })
);
